<template>
  <div class="ifInput" ref="r_ifInput" style="position:relative">
    <span v-if="isLostConn" class="offtip">you are offline</span>
    <textarea
      id="text-elem"
      v-model="message"
      placeholder="Input words you wanna say......"
      class="text-e"
      @keyup.enter="sendMsg"
    ></textarea>
    <div class="sendBox ">
      <div class="sendBox-left">
        <i class="img" @click="sendImage">
          <input
            ref="image"
            style="display: none"
            type="file"
            accept="image/png,image/gif,image/jpeg"
            @change="onImage"
          />
        </i>
        <i class="file" @click="sendFile">
          <input
            ref="file"
            style="display: none"
            type="file"
            accept="*.*"
            @change="onFile"
          />
        </i>
        <!--        <i class="audio" @click="sendAudio">-->
        <!--          <input-->
        <!--            ref="audio"-->
        <!--            style="display: none"-->
        <!--            type="file"-->
        <!--            accept="audio/aac"-->
        <!--            @change="onAudio"-->
        <!--          />-->
        <!--        </i>-->
        <!--        <i class="video" @click="sendVideo">-->
        <!--          <input-->
        <!--            ref="video"-->
        <!--            style="display: none"-->
        <!--            type="file"-->
        <!--            accept="video/mp4"-->
        <!--            @change="onVideo"-->
        <!--          />-->
        <!--        </i>-->
      </div>
      <div class="sendBox-right" @click="sendMsg">
        <i>Send</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SendBox",
  props: {
    roomName: {
      type: String,
      default: ""
    },
    isLostConn:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      show: false,
      message: ""
    };
  },
  watch: {
    message() {
      let msg = this.message.replace(/[\r\n]/g, "");
      this.$emit("preMsg", { text: msg });
    }
  },
  methods: {
    sendImage() {
      if (this.roomName === "") return;
      this.$refs.image.dispatchEvent(new MouseEvent("click"));
    },
    onImage(e) {
      let file = e.target.files[0];
      if (file.size > 100 * 1024 * 1024) {
        alert("文件发送最大100M！");
        return;
      }
      this.$emit("image", { file: file });
      this.$refs.image.value = "";
    },
    sendFile() {
      if (this.roomName === "") return;
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    onFile(e) {
      let file = e.target.files[0];
      if (file.size > 100 * 1024 * 1024) {
        alert("文件发送最大100M！");
        return;
      }
      this.$emit("file", { file: file });
      this.$refs.file.value = "";
    },
    sendMsg() {
      // if (this.roomName === "") return;
      let content = this.message.replace(/[\r\n]/g, "");
      if (content.length == 0) return;
      this.$emit("talk", this.message.replace(/[\r\n]/g, ""));
      this.message = "";
    }
  }
};
</script>

<style scoped></style>
